import { useTranslation } from "react-i18next";
import { Flex, Image, Text } from "@mantine/core";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { FormItem } from "../../../../FormItem";

export interface ThumbnailImageProps {
    campaign: CampaignQueryDataType;
}

export const ThumbnailImage = ({ campaign }: ThumbnailImageProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Flex>
                <FormItem label={t("campaign_thumbnailimage")} style={{ flex: 1 }}>
                    {campaign?.thumbnailImage?.src ? (
                        <Image mt="md" width={200} height={200} src={campaign.thumbnailImage.src} />
                    ) : (
                        <Text mt="md" color="dimmed" italic>
                            {t("campaign_thumbnailimage_missing")}
                        </Text>
                    )}
                </FormItem>
            </Flex>
        </>
    );
};
